import { Navigate, useLocation } from "react-router-dom";
import { canRoleAccessPath, getDefaultLandingPath } from "@/lib/portalModules";

export const ModuleAccessGuard = ({ children, routePath, user }) => {
  const location = useLocation();

  if (!user) {
    return children;
  }

  if (canRoleAccessPath(user.role, routePath)) {
    return children;
  }

  return <Navigate replace state={{ deniedFrom: location.pathname }} to={getDefaultLandingPath(user.role)} />;
};
